import React from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";

function Topbar() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      console.error("Logout Error:", error);
    }
  };

  return (
    <div style={topbarStyle}>
      {/* Empty div to push the logout button to the right */}
      <div></div>

      <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
        <div style={userInfo}>
          <span style={{ fontSize: "12px", color: "#94a3b8", opacity: 0.8 }}>Welcome</span>
          <span style={{ fontWeight: "700", color: "#fff", fontSize: "14px" }}>
            {auth.currentUser?.email?.split('@')[0].toUpperCase() || "GUEST"}
          </span>
        </div>
        
        <button 
          style={logoutBtn} 
          onMouseOver={(e) => e.target.style.boxShadow = "0 0 15px #FF4D4D"}
          onMouseOut={(e) => e.target.style.boxShadow = "none"}
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

const topbarStyle = {
  position: "absolute", // Changed from fixed to absolute to prevent scroll-glitch
  top: 0,
  right: 0,
  left: 0,
  height: "75px",
  background: "transparent", // Removed solid color to match glass theme
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "0 40px",
  zIndex: 10,
};

const userInfo = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  marginRight: "10px"
};

const logoutBtn = {
  padding: "10px 24px",
  background: "#FF4D4D",
  color: "white",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "700",
  fontSize: "14px",
  transition: "0.3s ease",
  textTransform: "uppercase",
  letterSpacing: "1px"
};

export default Topbar;